import { Component, Input, OnInit } from '@angular/core';
import { DatePipe, TitleCasePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ImagePreviewModalComponent } from '../../modals/image-preview-modal/image-preview-modal.component';
import { ConfirmationModalComponent } from '../../modals/confirmation-modal/confirmation-modal.component';

enum TraceabilityFilters {
  PICKUP,
  INVOICE,
  PTL,
  SHIPPING,
}

@Component({
  selector: 'lm-order-traceability',
  templateUrl: './order-traceability.component.html',
  styleUrls: ['./order-traceability.component.scss']
})
export class OrderTraceabilityComponent implements OnInit {
  public TraceabilityFilters = TraceabilityFilters;

  public columnsLabel = [
    {value: TraceabilityFilters.PICKUP, label: 'Enlèvement', class: 'lm-red-btn'},
    {value: TraceabilityFilters.INVOICE, label: 'Tri/Facturation', class: 'lm-orange-btn'},
    {value: TraceabilityFilters.PTL, label: 'PTL', class: 'lm-grey-btn'},
    {value: TraceabilityFilters.SHIPPING, label: 'Expédition', class: 'lm-blue-btn'},
  ];

  @Input() public order = null;
  @Input() public lavandierMap = new Map();
  @Input() public storageMap = new Map();

  public selectedFilter = TraceabilityFilters.PICKUP;

  constructor(
    private datePipe: DatePipe,
    private modalService: NgbModal,
  ) {
  }

  ngOnInit() {
  }

  getTraceabilityRows() {
    const rows = [];
    if (this.selectedFilter === TraceabilityFilters.PICKUP) {
      const id = this.order.id;
      const pickupOrderTransport = null;

      this.order.orderBags.forEach(bag => {
        rows.push({
          id,
          pickLavandier: pickupOrderTransport ? this.getLanvandierFullNameById(pickupOrderTransport.lavandierId) : null,
          pickDate: pickupOrderTransport ? this.datePipe.transform(pickupOrderTransport.doneAt, 'dd/MM/yyyy à HH:mm') : null,
          ref: bag.ref,
          bagId: bag.id,
          creation: bag.creation,
          creationDate: this.datePipe.transform(bag.createdAt, 'dd/MM/yyyy à HH:mm'),
          edit: bag.nbEdit > 0 ? 'oui' : 'non',
          type: bag.type,
          checkBy: this.getLanvandierFullNameById(bag.checkByLavandierId),
          checkDate: this.datePipe.transform(bag.checkAt, 'dd/MM/yyyy à HH:mm'),
        });
      });
    } else if (this.selectedFilter === TraceabilityFilters.INVOICE) {
      this.order.orderBags.forEach(bag => {
        bag.orderArticles.forEach(article => {
          article.orderArticleTrackingList.forEach(tracking => {
            rows.push({
              articleId: article.id,
              ref: tracking.ref,
              name: article.name,
              lavandier: this.getLanvandierFullNameById(article.lavandierId),
              date: this.datePipe.transform(tracking.createdAt, 'dd/MM/yyyy à HH:mm'),
              uploadId: article.uploadId,
            });
          });
        });
      });
    } else if (this.selectedFilter === TraceabilityFilters.PTL) {
      this.order.orderBags.forEach(bag => {
        bag.orderArticles.forEach(article => {
          article.orderArticleTrackingList.forEach(tracking => {
            rows.push({
              articleId: article.id,
              refArticle: tracking.ref,
              ref: tracking.storageId && this.storageMap.get(tracking.storageId) ? this.storageMap.get(tracking.storageId).ref : null,
              nbScan: tracking.nbScan,
              preTidiedByLavandier: this.getLanvandierFullNameById(tracking.preTidiedByLavandierId),
              preTidiedAt: this.datePipe.transform(tracking.preTidiedAt, 'dd/MM/yyyy à HH:mm'),
              tidiedByLavandier: this.getLanvandierFullNameById(tracking.tidiedByLavandierId),
              tidiedAt: this.datePipe.transform(tracking.tidiedAt, 'dd/MM/yyyy à HH:mm'),
              ts: tracking.trackingSheetId,
            });
          });
        });
      });
    } else if (this.selectedFilter === TraceabilityFilters.SHIPPING) {
      this.order.orderBags.forEach(bag => {
        bag.orderArticles.forEach(article => {
          article.orderArticleTrackingList.forEach(tracking => {
            rows.push({
              articleId: article.id,
              refArticle: tracking.ref,
              ts: tracking.trackingSheetId,
              factoryMissing: tracking.factoryMissing,
              lavandier: this.getLanvandierFullNameById(tracking.factoryByLavandierId),
              date: this.datePipe.transform(tracking.factoryAt, 'dd/MM/yyyy à HH:mm'),
            });
          });
        });
      });
    }
    return rows;
  }

  getTraceabilityColumns() {
    const columns = [];
    if (this.selectedFilter === TraceabilityFilters.PICKUP) {
      columns.push(
        {prop: 'id', name: 'N° commande'},
        {prop: 'pickLavandier', name: 'Lavandier Enlèvement'},
        {prop: 'pickDate', name: 'Date Enlèvement'},
        {prop: 'ref', name: 'Ref sac'},
        {prop: 'bagId', name: 'Id sac'},
        {prop: 'type', name: 'Type'},
        {prop: 'creation', name: 'Creation'},
        {prop: 'creationDate', name: 'Date création'},
        {prop: 'edit', name: 'Sac modifié ?'},
        {prop: 'checkBy', name: 'Check TL'},
        {prop: 'checkDate', name: 'Date Check Collecte'});
    } else if (this.selectedFilter === TraceabilityFilters.PTL) {
      columns.push(
        {prop: 'articleId', name: 'Id article'},
        {prop: 'refArticle', name: 'N° article'},
        {prop: 'ref', name: 'Nom emplacement PTL'},
        {prop: 'nbScan', name: 'Nombre passage PTL '},
        {prop: 'preTidiedByLavandier', name: 'Lavandier sortie pliage'},
        {prop: 'preTidiedAt', name: 'Date sortie pliage'},
        {prop: 'tidiedByLavandier', name: 'Lavandier PTL'},
        {prop: 'tidiedAt', name: 'Date PTL'},
        {prop: 'ts', name: 'N° TS'},
      );
    } else if (this.selectedFilter === TraceabilityFilters.SHIPPING) {
      columns.push(
        {prop: 'articleId', name: 'Id article'},
        {prop: 'refArticle', name: 'N° article'},
        {prop: 'ts', name: 'N° TS'},
        {prop: 'factoryMissing', name: 'Manquant Expédition'},
        {prop: 'lavandier', name: 'Lavandier expédition'},
        {prop: 'date', name: 'Expédié le'},
      );
    }
    return columns;
  }

  getLanvandierFullNameById(id: number) {
    const lavandier = this.lavandierMap.get(id);
    const lavandierFullName = lavandier ? lavandier.user.firstName + ' ' + lavandier.user.lastName : null;
    return new TitleCasePipe().transform(lavandierFullName);
  }

  openImagePreviewModal(event) {
    if (event.type === 'click') {
      event.cellElement.blur();
      const data = event.row;
      if (data.uploadId) {
        const imagePreviewModal = this.modalService.open(ImagePreviewModalComponent, {size: 'lg'});
        imagePreviewModal.componentInstance.imageList = [data];
        imagePreviewModal.componentInstance.selectedImage = data;
      } else {
        const confirmationModal = this.modalService.open(ConfirmationModalComponent, {size: 'lg'});
        confirmationModal.componentInstance.confirmationDesc = 'Pas de photo disponible';
        confirmationModal.componentInstance.cancelButtonText = 'Fermer';
      }
    }
  }
}
